/* ==============================================
   STUFFABLE THEME - JAVASCRIPT
   ============================================== */

document.addEventListener('DOMContentLoaded', function() {
  // Mobile Menu Toggle
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      mobileMenu.classList.toggle('is-open');
    });
  }
  
  // Product Form - Add to Cart
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');
      
      if (this.form) {
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }
    }
    
    async onSubmit(event) {
      event.preventDefault();
      
      if (this.submitButton.disabled) return;
      
      this.submitButton.disabled = true;
      const originalText = this.submitButton.textContent;
      this.submitButton.textContent = 'Adding...';
      
      const formData = new FormData(this.form);
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        const data = await response.json();
        
        if (response.ok) {
          // Update cart count
          this.updateCartCount();
          this.submitButton.textContent = 'Added!';
          setTimeout(() => {
            this.submitButton.textContent = originalText;
            this.submitButton.disabled = false;
          }, 2000);
        } else {
          throw new Error(data.description || 'Error adding to cart');
        }
      } catch (error) {
        console.error('Error:', error);
        this.submitButton.textContent = 'Error';
        setTimeout(() => {
          this.submitButton.textContent = originalText;
          this.submitButton.disabled = false;
        }, 2000);
      }
    }
    
    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const countElements = document.querySelectorAll('[data-cart-count]');
        countElements.forEach(el => {
          el.textContent = cart.item_count;
        });
      } catch (error) {
        console.error('Error updating cart count:', error);
      }
    }
  }
  
  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }
  
  // Quantity Buttons
  document.querySelectorAll('[data-quantity-minus]').forEach(button => {
    button.addEventListener('click', function() {
      const input = this.parentElement.querySelector('input');
      const value = parseInt(input.value) || 1;
      if (value > 1) {
        input.value = value - 1;
      }
    });
  });
  
  document.querySelectorAll('[data-quantity-plus]').forEach(button => {
    button.addEventListener('click', function() {
      const input = this.parentElement.querySelector('input');
      const value = parseInt(input.value) || 1;
      input.value = value + 1;
    });
  });
  
  // Product Image Gallery
  document.querySelectorAll('.product-main__thumbnail').forEach(thumbnail => {
    thumbnail.addEventListener('click', function() {
      const imageUrl = this.dataset.imageUrl;
      const featuredImage = document.querySelector('.product-main__image');
      
      if (featuredImage && imageUrl) {
        featuredImage.src = imageUrl;
        
        // Update active state
        document.querySelectorAll('.product-main__thumbnail').forEach(t => {
          t.classList.remove('product-main__thumbnail--active');
        });
        this.classList.add('product-main__thumbnail--active');
      }
    });
  });
  
  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;
      
      const target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
});
